namespace SPA {
	export namespace Contacts {
		export class DetailView extends Backbone.View<SPA.Contact> {
			public constructor(options?: Backbone.ViewOptions<SPA.Contact>) {
				super(options);
			}

			public preinitialize(options: Backbone.ViewOptions = {}): void {
				options.tagName = 'box';

				options.events = {
					'submit form': this.onDetailSubmit,
				};
			}

			public initialize(options?: Backbone.ViewOptions): void {
				// Init events
				this.listenTo(this.model, 'update', this.render);
			}

			public render(): DetailView {
				const salutationSelect = new ui.Form.Select(
					{
						blank: ' --- ',
						option: SPA.types.Convert.ToObjectList(SPA.types.Salutation),
						name: 'salutation',
						control: true,
						required: true
					}, this.model.Salutation || undefined
				);
				salutationSelect.Initialize();

				const stateSelect = new ui.Form.Select(
					{
						blank: ' --- ',
						option: SPA.types.Convert.ToObjectList(SPA.types.Address.State),
						name: 'state',
						control: true,
						required: true
					}, this.model.State || undefined
				);
				stateSelect.Initialize();

				const formBody = $('<form class="container-fluid">')
					.append('<h2>Details</h2>')
					.append(ui.$$.div().addClass('row')
						.append(SPA.gui.Bootstrap.Column('col-xs-2 form-group',
							'<label class="control-label">Anrede</label>',
								salutationSelect.Input()
							)
						)
						.append(ui.$$.div().addClass('col-xs-4 form-group').append($(`
							<label class="control-label">Vorname</label>
							<input class="form-control" type="text" name="name" value="${this.model.Name}">`))
						)
						.append(ui.$$.div().addClass('col-xs-4 form-group').append($(`
							<label class="control-label">Nachname</label>
							<input class="form-control" type="text" name="surname" value="${this.model.Surname}">`))
						)
						.append(ui.$$.div().addClass('col-xs-2 form-group').append($(`
							<label class="control-label">Titel</label>
							<input class="form-control" type="text" name="title" value="${this.model.Title}">`))
						)
					)
					.append(ui.$$.div().addClass('row')
						.append(ui.$$.div().addClass('col-xs-8 form-group').append($(`
							<label class="control-label">Straße</label>
							<input class="form-control" type="text" name="street" value="${this.model.Street}">`))
						)
						.append(ui.$$.div().addClass('col-xs-4 form-group').append($(`
							<label class="control-label">Haus-Nr.</label>
							<input class="form-control" type="text" name="housenumber" value="${this.model.HouseNumber}">`))
						)
					)
					.append(ui.$$.div().addClass('row')
						.append(ui.$$.div().addClass('col-xs-2 form-group').append($(`
							<label class="control-label">PLZ</label>
							<input class="form-control" type="text" name="postalcode" value="${this.model.PostalCode}">`))
						)
						.append(ui.$$.div().addClass('col-xs-5 form-group').append($(`
							<label class="control-label">Ort</label>
							<input class="form-control" type="text" name="city" value="${this.model.City}">`))
						)
						.append(ui.$$.div().addClass('col-xs-5 form-group')
							.append($(`<label class="control-label">Bundesland</label>`))
							.append(stateSelect.Input())
						)
					)
					.append(ui.$$.div().addClass('row')
						.append(ui.$$.div().addClass('col-xs-4 form-group').append($(`
							<label class="control-label">Telefon</label>
							<input class="form-control" type="text" name="phone" value="${this.model.Phone}">
							<input type="hidden" name="fax" value="${this.model.Fax}">`))
						)
						.append(ui.$$.div().addClass('col-xs-4 form-group').append($(`
							<label class="control-label">E-Mail</label>
							<input class="form-control" type="text" name="email" value="${this.model.Email}">`))
						)
						.append(ui.$$.div().addClass('col-xs-4 form-group').append($(`
							<label class="control-label">Mobil</label>
							<input class="form-control" type="text" name="mobile" value="${this.model.Mobile}">`))
						)
					)
					.append(ui.$$.div().addClass('row')
						.append(ui.$$.div().addClass('col-xs-12 form-group').append($(`
							<label class="control-label">Interne Notizen</label>
							<textarea class="form-control" rows="8" name="notes">${this.model.Notes}</textarea>`))
						)
						.append(ui.$$.div().addClass('col-xs-12 form-group')
							.append('<button class="btn btn-success"><i class="fa fa-save"></i> Details speichern</button>')
						)
					)
					.append(`<input type="hidden" name="country" value="DE">`);

				this.$el.empty().append(formBody);

				return this;
			}

			private onDetailSubmit(e: JQuery.TriggeredEvent)
			{
				e.preventDefault();

				// Save button outside of form
				let form = $(e.currentTarget as HTMLFormElement).find('form');
				// Or Save button is part of the form
				if (form.length === 0) {
					form = $(e.target).closest('form');
				}

				const formElements = (e.currentTarget as HTMLFormElement).elements;
				const obj = {};
				for (const entry of formElements)
				{
					if (entry.name === '') {
						continue;
					}
					entry.name = entry.name.replace('demand.', '');

					const parts = entry.name.split('.');

					let subObj: any = obj;
					while (parts.length > 1) {
						const part = parts.shift();
						if (subObj[part] === undefined) {
							subObj[part] = {};
						}

						subObj = subObj[part];
					}
					const prop = parts[0];
					if (subObj[prop] === undefined) {
						subObj[prop] = entry.value;
					} else {
						if (!(subObj[prop] instanceof Array)) {
							subObj[prop] = [subObj[prop]];
						}
						subObj[prop].push(entry.value);
					}
				}

				app.getContactManager().saveDetails(this.model.ContactID, obj);
			}
		}
	}
}
